// import React, { useState } from "react";
// import createInstance from "../../api/axiosinstance";
// import { toast } from "react-toastify";
// import { IconButton } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";

// const InterviewerJoining = () => {
//   const aiDishaApi = createInstance("DISHA");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     mobile: "",
//     // stored as YYYY-MM-DD from <input type="date">
//     Date_of_birth: "",
//     address: {
//       H_No: "",
//       city: "",
//       state: "",
//       country: "",
//     },
//     password: "",
//     confirm_password: "",
//     role: "TP-Interviewer",
//     status: "InActive",
//     activation_status: "Pending",
//   });

//   // today's date in YYYY-MM-DD (for max attr & validation)
//   const todayStr = new Date().toISOString().split("T")[0];

//   // Handle input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (["H_No", "city", "state", "country"].includes(name)) {
//       setFormData((prev) => ({
//         ...prev,
//         address: { ...prev.address, [name]: value },
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   // Validate form inputs (includes 18+ and <120, no future date, mobile 6–9)
//   const validateForm = () => {
//     const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
//     // Indian mobile: starts with 6/7/8/9 and 10 digits
//     const phoneRegex = /^[6-9]\d{9}$/;

//     if (!formData.name.trim()) return "Name is required";
//     if (!formData.email || !emailRegex.test(formData.email))
//       return "Enter a valid email";
//     if (!formData.mobile || !phoneRegex.test(formData.mobile))
//       return "Enter a valid 10-digit Indian mobile number starting with 6, 7, 8, or 9";

//     // DOB validations (YYYY-MM-DD from <input type='date'>)
//     // Inside validateForm()
//     if (!formData.Date_of_birth) return "Date of birth is required";

//     const dob = new Date(formData.Date_of_birth);
//     const today = new Date();

//     // Invalid date check
//     if (isNaN(dob.getTime())) {
//       return "Enter a valid date of birth";
//     }

//     // Future date check
//     if (dob > today) {
//       return "Date of birth cannot be in the future";
//     }

//     // Age calculation
//     let age = today.getFullYear() - dob.getFullYear();
//     const monthDiff = today.getMonth() - dob.getMonth();
//     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
//       age--;
//     }

//     if (age < 18) {
//       return "You must be at least 18 years old to register as an interviewer";
//     }
//     if (age >= 120) {
//       return "Date of birth is not valid. Age cannot be 120 years or above.";
//     }
//     if (!formData.address.H_No.trim()) return "House No. is required";
//     if (!formData.address.city.trim()) return "City is required";
//     if (!formData.address.state.trim()) return "State is required";
//     if (!formData.address.country.trim()) return "Country is required";

//     if (!formData.password) return "Password is required";
//     if (formData.password.length < 6)
//       return "Password must be at least 6 characters";
//     if (formData.password !== formData.confirm_password)
//       return "Passwords do not match";

//     return null;
//   };

//   // Clear form
//   const clearForm = () => {
//     setFormData({
//       name: "",
//       email: "",
//       mobile: "",
//       Date_of_birth: "",
//       address: { H_No: "", city: "", state: "", country: "" },
//       password: "",
//       confirm_password: "",
//       role: "TP-Interviewer",
//       status: "InActive",
//       activation_status: "Pending",
//     });
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationError = validateForm();
//     if (validationError) {
//       toast.error(validationError);
//       return;
//     }
//     try {
//       setLoading(true);
//       const queryParams = new URLSearchParams({
//         password: formData.password,
//         confirm_password: formData.confirm_password,
//       }).toString();

//       const response = await aiDishaApi.post(
//         `/interviewer_register?${queryParams}`,
//         {
//           name: formData.name,
//           email: formData.email,
//           mobile: formData.mobile,
//           Date_of_birth: formData.Date_of_birth, // ← THIS IS ALREADY "1999-08-20" → PERFECT!
//           address: formData.address,
//           role: formData.role,
//           status: formData.status,
//           activation_status: formData.activation_status,
//         }
//       );

//       toast.success(response.data.message || "Registration successful!");
//       clearForm();
//       navigate("/otpVerification", {
//         state: { email: formData.email, source: "interviewerRegister" },
//       });
//     } catch (error) {
//       console.error(error);
//       const errMsg =
//         error.response?.data?.detail?.[0]?.msg ||
//         error.response?.data?.detail ||
//         "Registration failed. Please try again.";
//       toast.error(errMsg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container mt-4" style={{ maxWidth: "700px" }}>
//       <div
//         className="card"
//         style={{ backgroundColor: "white", borderRadius: "8px" }}
//       >
//         <div
//           className="card-header"
//           style={{
//             backgroundColor: "#033538",
//             color: "white",
//             borderRadius: "8px 8px 0 0",
//             textAlign: "center",
//           }}
//         >
//           <h5 className="mb-0" style={{ fontFamily: "Poppins" }}>
//             Interviewer Registration
//           </h5>
//         </div>

//         <form onSubmit={handleSubmit}>
//           <div className="card-body">
//             {/* Name */}
//             <div className="mb-3">
//               <label
//                 className="form-label"
//                 style={{ color: "#033538", fontWeight: 500 }}
//               >
//                 Full Name *
//               </label>
//               <input
//                 type="text"
//                 className="form-control form-control-sm"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 placeholder="Enter Full Name (e.g., John Doe)"
//                 autoComplete="name"
//                 required
//               />
//             </div>

//             {/* Email and Mobile */}
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label
//                   className="form-label"
//                   style={{ color: "#033538", fontWeight: 500 }}
//                 >
//                   Email *
//                 </label>
//                 <input
//                   type="email"
//                   className="form-control form-control-sm"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   placeholder="name@example.com"
//                   autoComplete="email"
//                   required
//                 />
//               </div>
//               <div className="col-md-6 mb-3">
//                 <label
//                   className="form-label"
//                   style={{ color: "#033538", fontWeight: 500 }}
//                 >
//                   Mobile *
//                 </label>
//                 <input
//                   type="tel"
//                   className="form-control form-control-sm"
//                   name="mobile"
//                   value={formData.mobile}
//                   onChange={handleChange}
//                   placeholder="10-digit Indian Mobile Number"
//                   autoComplete="tel"
//                   required
//                 />
//               </div>
//             </div>

//             {/* DOB with Calendar Picker */}
//             <div className="mb-3">
//               <label
//                 className="form-label"
//                 style={{ color: "#033538", fontWeight: 500 }}
//               >
//                 Date of Birth *
//               </label>
//               <input
//                 type="date"
//                 className="form-control form-control-sm"
//                 name="Date_of_birth"
//                 value={formData.Date_of_birth}
//                 onChange={handleChange}
//                 max={todayStr}
//                 required
//                 // Remove placeholder completely - it doesn't work reliably
//               />

//               {/* This is the magic: clear, visible, always correct format hint */}
//               <div className="form-text text-muted mt-1">
//                 <small>
//                   <i className="bi bi-calendar-event me-1"></i>
//                   Please select your date of birth (e.g.,{" "}
//                   <strong>20/08/1999</strong>)
//                 </small>
//               </div>

//               {/* Optional: Show selected date in Indian format for confirmation */}
//               {formData.Date_of_birth && (
//                 <small className="text-success d-block mt-1">
//                   Selected:{" "}
//                   {new Date(formData.Date_of_birth).toLocaleDateString("en-GB")}
//                   {/* Shows 20/08/1999 */}
//                 </small>
//               )}
//             </div>

//             {/* Address */}
//             <h6
//               style={{
//                 color: "#033538",
//                 fontWeight: "bold",
//                 textAlign: "center",
//                 marginTop: "10px",
//               }}
//             >
//               Address
//             </h6>
//             <div className="row">
//               {["H_No", "city", "state", "country"].map((field, i) => (
//                 <div className="col-md-6 mb-3" key={i}>
//                   <input
//                     type="text"
//                     placeholder={
//                       field === "H_No"
//                         ? "House No"
//                         : field.charAt(0).toUpperCase() + field.slice(1)
//                     }
//                     className="form-control form-control-sm"
//                     name={field}
//                     value={formData.address[field]}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>
//               ))}
//             </div>

//             {/* Password Fields */}
//             <div className="row">
//               <div className="col-md-6 mb-3">
//                 <label
//                   className="form-label"
//                   style={{ color: "#033538", fontWeight: 500 }}
//                 >
//                   Password *
//                 </label>
//                 <div className="input-group input-group-sm">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     className="form-control"
//                     name="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     placeholder="Min. 6 Characters"
//                     autoComplete="new-password"
//                     required
//                   />
//                   <span className="input-group-text bg-black">
//                     <IconButton
//                       onClick={() => setShowPassword((prev) => !prev)}
//                       edge="end"
//                       size="small"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </span>
//                 </div>
//               </div>

//               <div className="col-md-6 mb-3">
//                 <label
//                   className="form-label"
//                   style={{ color: "#033538", fontWeight: 500 }}
//                 >
//                   Confirm Password *
//                 </label>
//                 <div className="input-group input-group-sm">
//                   <input
//                     type={showConfirmPassword ? "text" : "password"}
//                     className="form-control"
//                     name="confirm_password"
//                     value={formData.confirm_password}
//                     onChange={handleChange}
//                     placeholder="Re-enter Password"
//                     autoComplete="new-password"
//                     required
//                   />
//                   <span className="input-group-text bg-black">
//                     <IconButton
//                       onClick={() => setShowConfirmPassword((prev) => !prev)}
//                       edge="end"
//                       size="small"
//                     >
//                       {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="card-footer d-flex justify-content-end border-0">
//             <button
//               type="button"
//               className="btn btn-outline-secondary btn-sm me-2"
//               onClick={clearForm}
//               disabled={loading}
//             >
//               Clear
//             </button>
//             <button
//               type="submit"
//               className="btn btn-sm"
//               style={{ backgroundColor: "#033538", color: "white" }}
//               disabled={loading}
//             >
//               {loading ? "Registering..." : "Submit"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default InterviewerJoining;


































// import React, { useState } from "react";
// import createInstance from "../../api/axiosinstance";
// import { toast } from "react-toastify";
// import { IconButton } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";

// // Responsive styles
// const styles = `
//   @media (max-width: 1024px) {
//     .interviewer-container {
//       grid-template-columns: 1fr !important;
//     }
    
//     .sidebar-benefits {
//       position: static !important;
//       top: auto !important;
//     }
//   }
  
//   @media (max-width: 768px) {
//     .interviewer-main-div {
//       padding: 20px 8px !important;
//     }
    
//     .interviewer-grid {
//       grid-template-columns: 1fr 1fr !important;
//     }
    
//     .sidebar-benefits {
//       padding: 24px !important;
//     }
//   }
  
//   @media (max-width: 480px) {
//     .interviewer-grid {
//       grid-template-columns: 1fr !important;
//     }
//   }
// `;

// const InterviewerJoining = () => {
//   const aiDishaApi = createInstance("DISHA");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const navigate = useNavigate();

//   // Color variables from your application
//   const colors = {
//     primary: "linear-gradient(135deg,#f9f9f9,#e3e3e3)",
//     secondary: "linear-gradient(135deg,#f9f9f9,#e3e3e3)",
//     accent: "#e59d02",
//     border: "#d6d6d6",
//     text: "#000000",
//     textSecondary: "red",
//     background: "white",
//     hoverBg: "rgba(233, 69, 96, 0.1)",
//   };

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     mobile: "",
//     Date_of_birth: "",
//     address: {
//       H_No: "",
//       city: "",
//       state: "",
//       country: "",
//     },
//     password: "",
//     confirm_password: "",
//     role: "TP-Interviewer",
//     status: "InActive",
//     activation_status: "Pending",
//   });

//   const todayStr = new Date().toISOString().split("T")[0];

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (["H_No", "city", "state", "country"].includes(name)) {
//       setFormData((prev) => ({
//         ...prev,
//         address: { ...prev.address, [name]: value },
//       }));
//     } else {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const validateForm = () => {
//     const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
//     const phoneRegex = /^[6-9]\d{9}$/;

//     if (!formData.name.trim()) return "Name is required";
//     if (!formData.email || !emailRegex.test(formData.email))
//       return "Enter a valid email";
//     if (!formData.mobile || !phoneRegex.test(formData.mobile))
//       return "Enter a valid 10-digit Indian mobile number starting with 6, 7, 8, or 9";

//     if (!formData.Date_of_birth) return "Date of birth is required";

//     const dob = new Date(formData.Date_of_birth);
//     const today = new Date();

//     if (isNaN(dob.getTime())) {
//       return "Enter a valid date of birth";
//     }

//     if (dob > today) {
//       return "Date of birth cannot be in the future";
//     }

//     let age = today.getFullYear() - dob.getFullYear();
//     const monthDiff = today.getMonth() - dob.getMonth();
//     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
//       age--;
//     }

//     if (age < 18) {
//       return "You must be at least 18 years old to register as an interviewer";
//     }
//     if (age >= 120) {
//       return "Date of birth is not valid. Age cannot be 120 years or above.";
//     }
//     if (!formData.address.H_No.trim()) return "House No. is required";
//     if (!formData.address.city.trim()) return "City is required";
//     if (!formData.address.state.trim()) return "State is required";
//     if (!formData.address.country.trim()) return "Country is required";

//     if (!formData.password) return "Password is required";
//     if (formData.password.length < 6)
//       return "Password must be at least 6 characters";
//     if (formData.password !== formData.confirm_password)
//       return "Passwords do not match";

//     return null;
//   };

//   const clearForm = () => {
//     setFormData({
//       name: "",
//       email: "",
//       mobile: "",
//       Date_of_birth: "",
//       address: { H_No: "", city: "", state: "", country: "" },
//       password: "",
//       confirm_password: "",
//       role: "TP-Interviewer",
//       status: "InActive",
//       activation_status: "Pending",
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const validationError = validateForm();
//     if (validationError) {
//       toast.error(validationError);
//       return;
//     }
//     try {
//       setLoading(true);
//       const queryParams = new URLSearchParams({
//         password: formData.password,
//         confirm_password: formData.confirm_password,
//       }).toString();

//       const response = await aiDishaApi.post(
//         `/interviewer_register?${queryParams}`,
//         {
//           name: formData.name,
//           email: formData.email,
//           mobile: formData.mobile,
//           Date_of_birth: formData.Date_of_birth,
//           address: formData.address,
//           role: formData.role,
//           status: formData.status,
//           activation_status: formData.activation_status,
//         }
//       );

//       toast.success(response.data.message || "Registration successful!");
//       clearForm();
//       navigate("/otpVerification", {
//         state: { email: formData.email, source: "interviewerRegister" },
//       });
//     } catch (error) {
//       console.error(error);
//       const errMsg =
//         error.response?.data?.detail?.[0]?.msg ||
//         error.response?.data?.detail ||
//         "Registration failed. Please try again.";
//       toast.error(errMsg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <style>{styles}</style>
//       <div style={{
//         display:"flex",
//         flexDirection:"row",
//         alignItems:"center",
//         justifyContent:"center"
//       }}>
//       <div
//         className="interviewer-main-div"
//         style={{
//           background: "linear-gradient(135deg, #f5f5f5 0%, #fafafa 100%)",
//           minHeight: "100vh",
//           paddingTop: "40px",
//           paddingBottom: "40px",
//         }}
//       >
//         <div
//           className="interviewer-container"
//           style={{
//             maxWidth: "1400px",
//             margin: "0 auto",
//             padding: "0 16px",
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr",
//             gap: "32px",
//             alignItems: "start",
//           }}
//         >
//         <div
//           style={{
//             background: colors.background,
//             borderRadius: "24px",
//             border: `1px solid ${colors.border}`,
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
//             overflow: "hidden",
//           }}
//         >
//           {/* Header */}
//           <div
//             style={{
//               background: colors.accent,
//               padding: "24px",
//               textAlign: "center",
//               borderBottom: `1px solid ${colors.border}`,
//             }}
//           >
//             <h3
//               style={{
//                 margin: "0",
//                 fontSize: "24px",
//                 fontWeight: "600",
//                 color: colors.text,
//                 fontFamily: "'Geist', 'Inter', sans-serif",
//                 letterSpacing: "0.3px",
//               }}
//             >
//               Interviewer Registration
//             </h3>
//             <p
//               style={{
//                 margin: "8px 0 0 0",
//                 fontSize: "14px",
//                 color: colors.textSecondary === "red" ? "#666" : colors.textSecondary,
//                 fontFamily: "'Geist', 'Inter', sans-serif",
//               }}
//             >
//               Create your interviewer account
//             </p>
//           </div>

//           {/* Form Container */}
//           <form onSubmit={handleSubmit} style={{ padding: "32px" }}>
//             {/* Full Name */}
//             <div style={{ marginBottom: "20px" }}>
//               <label
//                 style={{
//                   display: "block",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                   color: colors.text,
//                   marginBottom: "8px",
//                   fontFamily: "'Geist', 'Inter', sans-serif",
//                 }}
//               >
//                 Full Name <span style={{ color: colors.textSecondary }}>*</span>
//               </label>
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 placeholder="Jane Doe"
//                 autoComplete="name"
//                 required
//                 style={{
//                   width: "100%",
//                   padding: "10px 12px",
//                   fontSize: "14px",
//                   border: `1px solid ${colors.border}`,
//                   borderRadius: "12px",
//                   background: `rgba(255, 255, 255, 0.6)`,
//                   color: colors.text,
//                   fontFamily: "'Geist', 'Inter', sans-serif",
//                   outline: "none",
//                   transition: "all 0.3s ease",
//                   boxSizing: "border-box",
//                 }}
//                 onFocus={(e) => {
//                   e.target.style.borderColor = colors.accent;
//                   e.target.style.boxShadow = `0 0 0 3px ${colors.hoverBg}`;
//                 }}
//                 onBlur={(e) => {
//                   e.target.style.borderColor = colors.border;
//                   e.target.style.boxShadow = "none";
//                 }}
//               />
//             </div>

//             {/* Email and Mobile Row */}
//             <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "20px" }}>
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: colors.text,
//                     marginBottom: "8px",
//                     fontFamily: "'Geist', 'Inter', sans-serif",
//                   }}
//                 >
//                   Email <span style={{ color: colors.textSecondary }}>*</span>
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   placeholder="you@company.com"
//                   autoComplete="email"
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "10px 12px",
//                     fontSize: "14px",
//                     border: `1px solid ${colors.border}`,
//                     borderRadius: "12px",
//                     background: `rgba(255, 255, 255, 0.6)`,
//                     color: colors.text,
//                     fontFamily: "'Geist', 'Inter', sans-serif",
//                     outline: "none",
//                     transition: "all 0.3s ease",
//                     boxSizing: "border-box",
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.borderColor = colors.accent;
//                     e.target.style.boxShadow = `0 0 0 3px ${colors.hoverBg}`;
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.borderColor = colors.border;
//                     e.target.style.boxShadow = "none";
//                   }}
//                 />
//               </div>
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: colors.text,
//                     marginBottom: "8px",
//                     fontFamily: "'Geist', 'Inter', sans-serif",
//                   }}
//                 >
//                   Mobile <span style={{ color: colors.textSecondary }}>*</span>
//                 </label>
//                 <input
//                   type="tel"
//                   name="mobile"
//                   value={formData.mobile}
//                   onChange={handleChange}
//                   placeholder="98XXXXXXXX"
//                   autoComplete="tel"
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "10px 12px",
//                     fontSize: "14px",
//                     border: `1px solid ${colors.border}`,
//                     borderRadius: "12px",
//                     background: `rgba(255, 255, 255, 0.6)`,
//                     color: colors.text,
//                     fontFamily: "'Geist', 'Inter', sans-serif",
//                     outline: "none",
//                     transition: "all 0.3s ease",
//                     boxSizing: "border-box",
//                   }}
//                   onFocus={(e) => {
//                     e.target.style.borderColor = colors.accent;
//                     e.target.style.boxShadow = `0 0 0 3px ${colors.hoverBg}`;
//                   }}
//                   onBlur={(e) => {
//                     e.target.style.borderColor = colors.border;
//                     e.target.style.boxShadow = "none";
//                   }}
//                 />
//               </div>
//             </div>

//             {/* Date of Birth */}
//             <div style={{ marginBottom: "20px" }}>
//               <label
//                 style={{
//                   display: "block",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                   color: colors.text,
//                   marginBottom: "8px",
//                   fontFamily: "'Geist', 'Inter', sans-serif",
//                 }}
//               >
//                 Date of Birth <span style={{ color: colors.textSecondary }}>*</span>
//               </label>
//               <input
//                 type="date"
//                 name="Date_of_birth"
//                 value={formData.Date_of_birth}
//                 onChange={handleChange}
//                 max={todayStr}
//                 required
//                 style={{
//                   width: "100%",
//                   padding: "10px 12px",
//                   fontSize: "14px",
//                   border: `1px solid ${colors.border}`,
//                   borderRadius: "12px",
//                   background: `rgba(255, 255, 255, 0.6)`,
//                   color: colors.text,
//                   fontFamily: "'Geist', 'Inter', sans-serif",
//                   outline: "none",
//                   transition: "all 0.3s ease",
//                   boxSizing: "border-box",
//                 }}
//                 onFocus={(e) => {
//                   e.target.style.borderColor = colors.accent;
//                   e.target.style.boxShadow = `0 0 0 3px ${colors.hoverBg}`;
//                 }}
//                 onBlur={(e) => {
//                   e.target.style.borderColor = colors.border;
//                   e.target.style.boxShadow = "none";
//                 }}
//               />
//               {formData.Date_of_birth && (
//                 <small
//                   style={{
//                     display: "block",
//                     marginTop: "6px",
//                     color: "#059669",
//                     fontSize: "13px",
//                     fontFamily: "'Geist', 'Inter', sans-serif",
//                   }}
//                 >
//                   Selected: {new Date(formData.Date_of_birth).toLocaleDateString("en-GB")}
//                 </small>
//               )}
//             </div>

//             {/* Address Section */}
//             <div style={{ marginBottom: "24px" }}>
//               <h6
//                 style={{
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   color: colors.text,
//                   textAlign: "center",
//                   marginBottom: "16px",
//                   textTransform: "uppercase",
//                   letterSpacing: "0.5px",
//                   fontFamily: "'Geist', 'Inter', sans-serif",
//                 }}
//               >
//                 Address Details
//               </h6>
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
//                 {["H_No", "city", "state", "country"].map((field, i) => (
//                   <input
//                     key={i}
//                     type="text"
//                     placeholder={
//                       field === "H_No"
//                         ? "House No"
//                         : field.charAt(0).toUpperCase() + field.slice(1)
//                     }
//                     name={field}
//                     value={formData.address[field]}
//                     onChange={handleChange}
//                     required
//                     style={{
//                       padding: "10px 12px",
//                       fontSize: "14px",
//                       border: `1px solid ${colors.border}`,
//                       borderRadius: "12px",
//                       background: `rgba(255, 255, 255, 0.6)`,
//                       color: colors.text,
//                       fontFamily: "'Geist', 'Inter', sans-serif",
//                       outline: "none",
//                       transition: "all 0.3s ease",
//                       boxSizing: "border-box",
//                     }}
//                     onFocus={(e) => {
//                       e.target.style.borderColor = colors.accent;
//                       e.target.style.boxShadow = `0 0 0 3px ${colors.hoverBg}`;
//                     }}
//                     onBlur={(e) => {
//                       e.target.style.borderColor = colors.border;
//                       e.target.style.boxShadow = "none";
//                     }}
//                   />
//                 ))}
//               </div>
//             </div>

//             {/* Password Fields */}
//             <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "24px" }}>
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: colors.text,
//                     marginBottom: "8px",
//                     fontFamily: "'Geist', 'Inter', sans-serif",
//                   }}
//                 >
//                   Password <span style={{ color: colors.textSecondary }}>*</span>
//                 </label>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     border: `1px solid ${colors.border}`,
//                     borderRadius: "12px",
//                     background: `rgba(255, 255, 255, 0.6)`,
//                     transition: "all 0.3s ease",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.borderColor = colors.accent;
//                     e.currentTarget.style.boxShadow = `0 0 0 3px ${colors.hoverBg}`;
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.borderColor = colors.border;
//                     e.currentTarget.style.boxShadow = "none";
//                   }}
//                 >
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     name="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     placeholder="Min. 6 characters"
//                     autoComplete="new-password"
//                     required
//                     style={{
//                       flex: "1",
//                       border: "none",
//                       padding: "10px 12px",
//                       fontSize: "14px",
//                       background: "transparent",
//                       color: colors.text,
//                       fontFamily: "'Geist', 'Inter', sans-serif",
//                       outline: "none",
//                     }}
//                   />
//                   <IconButton
//                     onClick={() => setShowPassword((prev) => !prev)}
//                     edge="end"
//                     size="small"
//                     style={{ color: colors.accent }}
//                   >
//                     {showPassword ? (
//                       <VisibilityOff style={{ fontSize: "20px" }} />
//                     ) : (
//                       <Visibility style={{ fontSize: "20px" }} />
//                     )}
//                   </IconButton>
//                 </div>
//               </div>

//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: colors.text,
//                     marginBottom: "8px",
//                     fontFamily: "'Geist', 'Inter', sans-serif",
//                   }}
//                 >
//                   Confirm Password <span style={{ color: colors.textSecondary }}>*</span>
//                 </label>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     border: `1px solid ${colors.border}`,
//                     borderRadius: "12px",
//                     background: `rgba(255, 255, 255, 0.6)`,
//                     transition: "all 0.3s ease",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.borderColor = colors.accent;
//                     e.currentTarget.style.boxShadow = `0 0 0 3px ${colors.hoverBg}`;
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.borderColor = colors.border;
//                     e.currentTarget.style.boxShadow = "none";
//                   }}
//                 >
//                   <input
//                     type={showConfirmPassword ? "text" : "password"}
//                     name="confirm_password"
//                     value={formData.confirm_password}
//                     onChange={handleChange}
//                     placeholder="Re-enter password"
//                     autoComplete="new-password"
//                     required
//                     style={{
//                       flex: "1",
//                       border: "none",
//                       padding: "10px 12px",
//                       fontSize: "14px",
//                       background: "transparent",
//                       color: colors.text,
//                       fontFamily: "'Geist', 'Inter', sans-serif",
//                       outline: "none",
//                     }}
//                   />
//                   <IconButton
//                     onClick={() => setShowConfirmPassword((prev) => !prev)}
//                     edge="end"
//                     size="small"
//                     style={{ color: colors.accent }}
//                   >
//                     {showConfirmPassword ? (
//                       <VisibilityOff style={{ fontSize: "20px" }} />
//                     ) : (
//                       <Visibility style={{ fontSize: "20px" }} />
//                     )}
//                   </IconButton>
//                 </div>
//               </div>
//             </div>

//             {/* Divider */}
//             <div
//               style={{
//                 height: "1px",
//                 background: colors.border,
//                 marginBottom: "24px",
//               }}
//             />

//             {/* Buttons */}
//             <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
//               <button
//                 type="button"
//                 onClick={clearForm}
//                 disabled={loading}
//                 style={{
//                   padding: "10px 24px",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                   border: `1.5px solid ${colors.border}`,
//                   borderRadius: "12px",
//                   background: colors.background,
//                   color: colors.text,
//                   cursor: loading ? "not-allowed" : "pointer",
//                   transition: "all 0.3s ease",
//                   fontFamily: "'Geist', 'Inter', sans-serif",
//                   opacity: loading ? 0.6 : 1,
//                 }}
//                 onMouseEnter={(e) => {
//                   if (!loading) {
//                     e.target.style.background = colors.hoverBg;
//                     e.target.style.borderColor = colors.accent;
//                   }
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.background = colors.background;
//                   e.target.style.borderColor = colors.border;
//                 }}
//               >
//                 Clear
//               </button>
//               <button
//                 type="submit"
//                 disabled={loading}
//                 style={{
//                   padding: "10px 32px",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   border: "none",
//                   borderRadius: "12px",
//                   background: colors.accent,
//                   color: colors.text,
//                   cursor: loading ? "not-allowed" : "pointer",
//                   transition: "all 0.3s ease",
//                   fontFamily: "'Geist', 'Inter', sans-serif",
//                   opacity: loading ? 0.7 : 1,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "8px",
//                 }}
//                 onMouseEnter={(e) => {
//                   if (!loading) {
//                     e.target.style.transform = "translateY(-2px)";
//                     e.target.style.boxShadow = "0 8px 16px rgba(229, 157, 2, 0.3)";
//                   }
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.transform = "translateY(0)";
//                   e.target.style.boxShadow = "none";
//                 }}
//               >
//                 {loading ? "Registering..." : "Submit & Continue"}
//               </button>
//             </div>

//             {/* Footer Text */}
//             <p
//               style={{
//                 marginTop: "16px",
//                 fontSize: "12px",
//                 color: "#666",
//                 textAlign: "center",
//                 fontFamily: "'Geist', 'Inter', sans-serif",
//               }}
//             >
//               By continuing, you agree to our Terms and Privacy Policy.
//             </p>
//           </form>
//         </div>
//       </div>

//       {/* Right Sidebar - Benefits Section */}
//       <div
//         className="sidebar-benefits"
//         style={{
//           background: `linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.2) 100%)`,
//           backdropFilter: "blur(10px)",
//           borderRadius: "24px",
//           border: `1px solid ${colors.border}`,
//           padding: "32px",
//           height: "fit-content",
//           position: "sticky",
//           top: "40px",
//         }}
//       >
//         {/* Benefits Title */}
//         <h3
//           style={{
//             fontSize: "24px",
//             fontWeight: "600",
//             color: colors.text,
//             marginBottom: "8px",
//             fontFamily: "'Geist', 'Inter', sans-serif",
//             letterSpacing: "0.3px",
//           }}
//         >
//           Why Join Us?
//         </h3>
//         <p
//           style={{
//             fontSize: "14px",
//             color: "#666",
//             marginBottom: "24px",
//             fontFamily: "'Geist', 'Inter', sans-serif",
//             lineHeight: "1.6",
//           }}
//         >
//           Become a third-party interviewer and unlock earning opportunities
//         </p>

//         {/* Main Benefits List */}
//         <ul
//           style={{
//             listStyle: "none",
//             padding: "0",
//             margin: "0 0 32px 0",
//           }}
//         >
//           <li
//             style={{
//               display: "flex",
//               gap: "12px",
//               marginBottom: "16px",
//               alignItems: "flex-start",
//               fontFamily: "'Geist', 'Inter', sans-serif",
//             }}
//           >
//             <span
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 minWidth: "24px",
//                 width: "24px",
//                 height: "24px",
//                 borderRadius: "8px",
//                 background: colors.hoverBg,
//                 border: `1.5px solid ${colors.accent}`,
//                 color: colors.accent,
//                 fontSize: "14px",
//                 fontWeight: "bold",
//                 flexShrink: 0,
//                 marginTop: "2px",
//               }}
//             >
//               ✓
//             </span>
//             <div>
//               <p
//                 style={{
//                   margin: "0 0 4px 0",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   color: colors.text,
//                 }}
//               >
//                 Earn on Your Weekend
//               </p>
//               <p
//                 style={{
//                   margin: "0",
//                   fontSize: "13px",
//                   color: "#666",
//                   lineHeight: "1.5",
//                 }}
//               >
//                 Conduct interviews at your own pace during weekends and earn competitive compensation
//               </p>
//             </div>
//           </li>

//           <li
//             style={{
//               display: "flex",
//               gap: "12px",
//               marginBottom: "16px",
//               alignItems: "flex-start",
//               fontFamily: "'Geist', 'Inter', sans-serif",
//             }}
//           >
//             <span
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 minWidth: "24px",
//                 width: "24px",
//                 height: "24px",
//                 borderRadius: "8px",
//                 background: colors.hoverBg,
//                 border: `1.5px solid ${colors.accent}`,
//                 color: colors.accent,
//                 fontSize: "14px",
//                 fontWeight: "bold",
//                 flexShrink: 0,
//                 marginTop: "2px",
//               }}
//             >
//               ✓
//             </span>
//             <div>
//               <p
//                 style={{
//                   margin: "0 0 4px 0",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   color: colors.text,
//                 }}
//               >
//                 Side Income Opportunity
//               </p>
//               <p
//                 style={{
//                   margin: "0",
//                   fontSize: "13px",
//                   color: "#666",
//                   lineHeight: "1.5",
//                 }}
//               >
//                 Build your supplementary income without compromising your primary job
//               </p>
//             </div>
//           </li>

//           <li
//             style={{
//               display: "flex",
//               gap: "12px",
//               marginBottom: "16px",
//               alignItems: "flex-start",
//               fontFamily: "'Geist', 'Inter', sans-serif",
//             }}
//           >
//             <span
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 minWidth: "24px",
//                 width: "24px",
//                 height: "24px",
//                 borderRadius: "8px",
//                 background: colors.hoverBg,
//                 border: `1.5px solid ${colors.accent}`,
//                 color: colors.accent,
//                 fontSize: "14px",
//                 fontWeight: "bold",
//                 flexShrink: 0,
//                 marginTop: "2px",
//               }}
//             >
//               ✓
//             </span>
//             <div>
//               <p
//                 style={{
//                   margin: "0 0 4px 0",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   color: colors.text,
//                 }}
//               >
//                 Flexible Schedule
//               </p>
//               <p
//                 style={{
//                   margin: "0",
//                   fontSize: "13px",
//                   color: "#666",
//                   lineHeight: "1.5",
//                 }}
//               >
//                 Choose interview slots that fit your availability - complete control over your time
//               </p>
//             </div>
//           </li>

//           <li
//             style={{
//               display: "flex",
//               gap: "12px",
//               marginBottom: "16px",
//               alignItems: "flex-start",
//               fontFamily: "'Geist', 'Inter', sans-serif",
//             }}
//           >
//             <span
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 minWidth: "24px",
//                 width: "24px",
//                 height: "24px",
//                 borderRadius: "8px",
//                 background: colors.hoverBg,
//                 border: `1.5px solid ${colors.accent}`,
//                 color: colors.accent,
//                 fontSize: "14px",
//                 fontWeight: "bold",
//                 flexShrink: 0,
//                 marginTop: "2px",
//               }}
//             >
//               ✓
//             </span>
//             <div>
//               <p
//                 style={{
//                   margin: "0 0 4px 0",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   color: colors.text,
//                 }}
//               >
//                 Professional Growth
//               </p>
//               <p
//                 style={{
//                   margin: "0",
//                   fontSize: "13px",
//                   color: "#666",
//                   lineHeight: "1.5",
//                 }}
//               >
//                 Enhance your interviewing skills and expand your professional network
//               </p>
//             </div>
//           </li>

//           <li
//             style={{
//               display: "flex",
//               gap: "12px",
//               marginBottom: "0",
//               alignItems: "flex-start",
//               fontFamily: "'Geist', 'Inter', sans-serif",
//             }}
//           >
//             <span
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 minWidth: "24px",
//                 width: "24px",
//                 height: "24px",
//                 borderRadius: "8px",
//                 background: colors.hoverBg,
//                 border: `1.5px solid ${colors.accent}`,
//                 color: colors.accent,
//                 fontSize: "14px",
//                 fontWeight: "bold",
//                 flexShrink: 0,
//                 marginTop: "2px",
//               }}
//             >
//               ✓
//             </span>
//             <div>
//               <p
//                 style={{
//                   margin: "0 0 4px 0",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   color: colors.text,
//                 }}
//               >
//                 Instant Payouts
//               </p>
//               <p
//                 style={{
//                   margin: "0",
//                   fontSize: "13px",
//                   color: "#666",
//                   lineHeight: "1.5",
//                 }}
//               >
//                 Get paid directly after each completed interview - quick and hassle-free
//               </p>
//             </div>
//           </li>
//         </ul>

//         {/* Testimonial Section */}
//         <div
//           style={{
//             background: `rgba(255, 255, 255, 0.4)`,
//             border: `1px solid ${colors.border}`,
//             borderRadius: "16px",
//             padding: "16px",
//             marginBottom: "24px",
//           }}
//         >
//           <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
//             <img
//               src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=96&auto=format&fit=crop"
//               alt="Interviewer"
//               style={{
//                 width: "40px",
//                 height: "40px",
//                 borderRadius: "8px",
//                 objectFit: "cover",
//                 border: `2px solid ${colors.accent}`,
//               }}
//             />
//             <div>
//               <p
//                 style={{
//                   margin: "0 0 6px 0",
//                   fontSize: "13px",
//                   color: colors.text,
//                   fontFamily: "'Geist', 'Inter', sans-serif",
//                   lineHeight: "1.5",
//                   fontWeight: "500",
//                 }}
//               >
//                 "I earned ₹15,000+ in just 4 weekends! The platform is user-friendly and payments are instant."
//               </p>
//               <p
//                 style={{
//                   margin: "0",
//                   fontSize: "12px",
//                   color: "#999",
//                   fontFamily: "'Geist', 'Inter', sans-serif",
//                   fontStyle: "italic",
//                 }}
//               >
//                 — Rajesh Kumar, Senior Developer
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Key Stats */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr",
//             gap: "12px",
//             marginBottom: "24px",
//           }}
//         >
//           <div
//             style={{
//               background: `rgba(229, 157, 2, 0.1)`,
//               border: `1px solid ${colors.accent}`,
//               borderRadius: "12px",
//               padding: "12px",
//               textAlign: "center",
//             }}
//           >
//             <p
//               style={{
//                 margin: "0 0 6px 0",
//                 fontSize: "18px",
//                 fontWeight: "700",
//                 color: colors.accent,
//                 fontFamily: "'Geist', 'Inter', sans-serif",
//               }}
//             >
//               ₹500+
//             </p>
//             <p
//               style={{
//                 margin: "0",
//                 fontSize: "12px",
//                 color: "#666",
//                 fontFamily: "'Geist', 'Inter', sans-serif",
//               }}
//             >
//               Per Interview
//             </p>
//           </div>
//           <div
//             style={{
//               background: `rgba(229, 157, 2, 0.1)`,
//               border: `1px solid ${colors.accent}`,
//               borderRadius: "12px",
//               padding: "12px",
//               textAlign: "center",
//             }}
//           >
//             <p
//               style={{
//                 margin: "0 0 6px 0",
//                 fontSize: "18px",
//                 fontWeight: "700",
//                 color: colors.accent,
//                 fontFamily: "'Geist', 'Inter', sans-serif",
//               }}
//             >
//               2000+
//             </p>
//             <p
//               style={{
//                 margin: "0",
//                 fontSize: "12px",
//                 color: "#666",
//                 fontFamily: "'Geist', 'Inter', sans-serif",
//               }}
//             >
//               Active Interviewers
//             </p>
//           </div>
//         </div>

//         {/* Trust Badges */}
//         <div
//           style={{
//             display: "flex",
//             gap: "8px",
//             flexWrap: "wrap",
//             paddingTop: "24px",
//             borderTop: `1px solid ${colors.border}`,
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "6px",
//               fontSize: "12px",
//               color: "#666",
//               fontFamily: "'Geist', 'Inter', sans-serif",
//             }}
//           >
//             <span style={{ color: colors.accent, fontWeight: "bold" }}>✓</span>
//             Secure Payments
//           </div>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "6px",
//               fontSize: "12px",
//               color: "#666",
//               fontFamily: "'Geist', 'Inter', sans-serif",
//             }}
//           >
//             <span style={{ color: colors.accent, fontWeight: "bold" }}>✓</span>
//             ISO Certified
//           </div>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "6px",
//               fontSize: "12px",
//               color: "#666",
//               fontFamily: "'Geist', 'Inter', sans-serif",
//             }}
//           >
//             <span style={{ color: colors.accent, fontWeight: "bold" }}>✓</span>
//             100% Transparent
//           </div>
//         </div>
//       </div>
//       </div>
//     </div>
//     </>
//   );
// };

// export default InterviewerJoining;

































import React, { useState } from "react";
import createInstance from "../../api/axiosinstance";
import { toast } from "react-toastify";
import {
  Container,
  Grid,
  Paper,
  TextField,
  Button,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const InterviewerJoining = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const aiDishaApi = createInstance("DISHA");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  // Color variables from your application
  const colors = {
    primary: "linear-gradient(135deg,#f9f9f9,#e3e3e3)",
    secondary: "linear-gradient(135deg,#f9f9f9,#e3e3e3)",
    accent: "rgb(37, 99, 235)",
    accent2: "#334155",
    border: "#d6d6d6",
    text: "#000000",
    textSecondary: "red",
    background: "white",
    hoverBg: "rgba(233, 69, 96, 0.1)",
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    Date_of_birth: "",
    address: {
      H_No: "",
      city: "",
      state: "",
      country: "",
    },
    password: "",
    confirm_password: "",
    role: "TP-Interviewer",
    status: "InActive",
    activation_status: "Pending",
  });

  const todayStr = new Date().toISOString().split("T")[0];

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (["H_No", "city", "state", "country"].includes(name)) {
      setFormData((prev) => ({
        ...prev,
        address: { ...prev.address, [name]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = () => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!formData.name.trim()) return "Name is required";
    if (!formData.email || !emailRegex.test(formData.email))
      return "Enter a valid email";
    if (!formData.mobile || !phoneRegex.test(formData.mobile))
      return "Enter a valid 10-digit Indian mobile number starting with 6, 7, 8, or 9";

    if (!formData.Date_of_birth) return "Date of birth is required";

    const dob = new Date(formData.Date_of_birth);
    const today = new Date();

    if (isNaN(dob.getTime())) {
      return "Enter a valid date of birth";
    }

    if (dob > today) {
      return "Date of birth cannot be in the future";
    }

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    if (age < 18) {
      return "You must be at least 18 years old to register as an interviewer";
    }
    if (age >= 120) {
      return "Date of birth is not valid. Age cannot be 120 years or above.";
    }
    if (!formData.address.H_No.trim()) return "House No. is required";
    if (!formData.address.city.trim()) return "City is required";
    if (!formData.address.state.trim()) return "State is required";
    if (!formData.address.country.trim()) return "Country is required";

    if (!formData.password) return "Password is required";
    if (formData.password.length < 6)
      return "Password must be at least 6 characters";
    if (formData.password !== formData.confirm_password)
      return "Passwords do not match";

    return null;
  };

  const clearForm = () => {
    setFormData({
      name: "",
      email: "",
      mobile: "",
      Date_of_birth: "",
      address: { H_No: "", city: "", state: "", country: "" },
      password: "",
      confirm_password: "",
      role: "TP-Interviewer",
      status: "InActive",
      activation_status: "Pending",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      toast.error(validationError);
      return;
    }
    try {
      setLoading(true);
      const queryParams = new URLSearchParams({
        password: formData.password,
        confirm_password: formData.confirm_password,
      }).toString();

      const response = await aiDishaApi.post(
        `/interviewer_register?${queryParams}`,
        {
          name: formData.name,
          email: formData.email,
          mobile: formData.mobile,
          Date_of_birth: formData.Date_of_birth,
          address: formData.address,
          role: formData.role,
          status: formData.status,
          activation_status: formData.activation_status,
        }
      );

      toast.success(response.data.message || "Registration successful!");
      clearForm();
      navigate("/otpVerification", {
        state: { email: formData.email, source: "interviewerRegister" },
      });
    } catch (error) {
      console.error(error);
      const errMsg =
        error.response?.data?.detail?.[0]?.msg ||
        error.response?.data?.detail ||
        "Registration failed. Please try again.";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        // background: "linear-gradient(135deg, #f5f5f5 0%, #fafafa 100%)",
        background: colors.background,
        minHeight: "100vh",
        py: { xs: 3, md: 5 },
        px: { xs: 1, sm: 2 },
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 4 }}
          alignItems="flex-start"
          sx={{
            // display: "grid",
            // gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
            // gap: isMobile ? 2 : 3,
          }}
        >
          {/* LEFT COLUMN - FORM */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              sx={{
                borderRadius: "24px",
                overflow: "hidden",
                background: colors.primary,
                border: `1px solid ${colors.border}`,
                position: "relative",
                height: "850px",
              }}
            >
              {/* Header */}
              <Box
                sx={{
                  background: colors.accent2,
                  padding: "24px",
                  textAlign: "center",
                  borderBottom: `1px solid ${colors.border}`,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    color: colors.background,
                    letterSpacing: "0.3px",
                    mb: 1,
                  }}
                >
                  Interviewer Registration
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: colors.border,
                  }}
                >
                  Create your interviewer account
                </Typography>
              </Box>

              {/* Form Content */}
              <Box component="form" onSubmit={handleSubmit} sx={{ p: 4 }}>
                {/* Full Name */}
                <TextField
                  fullWidth
                  label="Full Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Jane Doe"
                  required
                  margin="normal"
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      backgroundColor: "rgba(255, 255, 255, 0.6)",
                      "& fieldset": {
                        borderColor: colors.border,
                      },
                      "&:hover fieldset": {
                        borderColor: colors.accent,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: colors.accent,
                        boxShadow: `0 0 0 3px ${colors.hoverBg}`,
                      },
                    },
                    "& .MuiInputBase-input::placeholder": {
                      opacity: 0.7,
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: colors.text,
                      fontWeight: 500,
                      "&.Mui-focused": {
                        color: colors.accent,
                      },
                    },
                  }}
                />

                {/* Email and Mobile Row */}
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="email"
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="you@company.com"
                      required
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          "& fieldset": {
                            borderColor: colors.border,
                          },
                          "&:hover fieldset": {
                            borderColor: colors.accent,
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: colors.accent,
                            boxShadow: `0 0 0 3px ${colors.hoverBg}`,
                          },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: colors.text,
                          fontWeight: 500,
                          "&.Mui-focused": {
                            color: colors.accent,
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="tel"
                      label="Mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      placeholder="98XXXXXXXX"
                      required
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          "& fieldset": {
                            borderColor: colors.border,
                          },
                          "&:hover fieldset": {
                            borderColor: colors.accent,
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: colors.accent,
                            boxShadow: `0 0 0 3px ${colors.hoverBg}`,
                          },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: colors.text,
                          fontWeight: 500,
                          "&.Mui-focused": {
                            color: colors.accent,
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Date of Birth */}
                <TextField
                  fullWidth
                  type="date"
                  label="Date of Birth"
                  name="Date_of_birth"
                  value={formData.Date_of_birth}
                  onChange={handleChange}
                  inputProps={{ max: todayStr }}
                  required
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                    sx: {
                      color: colors.text,
                      fontWeight: 500,
                      "&.Mui-focused": {
                        color: colors.accent,
                      },
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      backgroundColor: "rgba(255, 255, 255, 0.6)",
                      "& fieldset": {
                        borderColor: colors.border,
                      },
                      "&:hover fieldset": {
                        borderColor: colors.accent,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: colors.accent,
                        boxShadow: `0 0 0 3px ${colors.hoverBg}`,
                      },
                    },
                  }}
                />
                {formData.Date_of_birth && (
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      mt: 1,
                      color: "#059669",
                      fontWeight: 500,
                    }}
                  >
                    Selected:{" "}
                    {new Date(formData.Date_of_birth).toLocaleDateString(
                      "en-GB"
                    )}
                  </Typography>
                )}

                {/* Address Section */}
                <Typography
                  variant="h6"
                  sx={{
                    mt: 3,
                    mb: 2,
                    textAlign: "center",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    fontSize: "14px",
                    color: colors.text,
                  }}
                >
                  Address Details
                </Typography>

                <Grid container spacing={2}>
                  {[
                    { key: "H_No", label: "House No" },
                    { key: "city", label: "City" },
                    { key: "state", label: "State" },
                    { key: "country", label: "Country" },
                  ].map((field) => (
                    <Grid item xs={12} sm={6} key={field.key}>
                      <TextField
                        fullWidth
                        label={field.label}
                        name={field.key}
                        value={formData.address[field.key]}
                        onChange={handleChange}
                        placeholder={field.label}
                        required
                        variant="outlined"
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            backgroundColor: "rgba(255, 255, 255, 0.6)",
                            "& fieldset": {
                              borderColor: colors.border,
                            },
                            "&:hover fieldset": {
                              borderColor: colors.accent,
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: colors.accent,
                              boxShadow: `0 0 0 3px ${colors.hoverBg}`,
                            },
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: colors.text,
                            fontWeight: 500,
                            "&.Mui-focused": {
                              color: colors.accent,
                            },
                          },
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>

                {/* Password Fields */}
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Min. 6 characters"
                      required
                      variant="outlined"
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                              size="small"
                              sx={{ color: colors.accent }}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          "& fieldset": {
                            borderColor: colors.border,
                          },
                          "&:hover fieldset": {
                            borderColor: colors.accent,
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: colors.accent,
                            boxShadow: `0 0 0 3px ${colors.hoverBg}`,
                          },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: colors.text,
                          fontWeight: 500,
                          "&.Mui-focused": {
                            color: colors.accent,
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Confirm Password"
                      name="confirm_password"
                      type={showConfirmPassword ? "text" : "password"}
                      value={formData.confirm_password}
                      onChange={handleChange}
                      placeholder="Re-enter password"
                      required
                      variant="outlined"
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }
                              edge="end"
                              size="small"
                              sx={{ color: colors.accent }}
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "rgba(255, 255, 255, 0.6)",
                          "& fieldset": {
                            borderColor: colors.border,
                          },
                          "&:hover fieldset": {
                            borderColor: colors.accent,
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: colors.accent,
                            boxShadow: `0 0 0 3px ${colors.hoverBg}`,
                          },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: colors.text,
                          fontWeight: 500,
                          "&.Mui-focused": {
                            color: colors.accent,
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Divider */}
                <Box
                  sx={{
                    height: "1px",
                    background: colors.border,
                    my: 3,
                  }}
                />

                {/* Buttons */}
                <Box sx={{ display: "flex", gap: 1.5, justifyContent: "flex-end" }}>
                  <Button
                    type="button"
                    onClick={clearForm}
                    disabled={loading}
                    variant="outlined"
                    sx={{
                      borderColor: colors.border,
                      color: colors.text,
                      borderRadius: "12px",
                      textTransform: "none",
                      fontWeight: 500,
                      px: 3,
                      "&:hover": {
                        // background: colors.hoverBg,
                        color:colors.accent,
                        borderColor: colors.accent,
                      },
                    }}
                  >
                    Clear
                  </Button>
                  <Button
                    type="submit"
                    disabled={loading}
                    variant="contained"
                    sx={{
                      backgroundColor: colors.accent,
                      color: colors.background,
                      borderRadius: "12px",
                      textTransform: "none",
                      fontWeight: 600,
                      px: 4,
                      "&:hover": {
                        backgroundColor: colors.accent,
                        // boxShadow: `0 8px 16px rgba(229, 157, 2, 0.3)`,
                        transform: "translateY(-2px)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    {loading ? "Registering..." : "Submit & Continue"}
                  </Button>
                </Box>

                {/* Footer Text */}
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mt: 2,
                    textAlign: "center",
                    color: "#666",
                  }}
                >
                  By continuing, you agree to our Terms and Privacy Policy.
                </Typography>
              </Box>
            </Paper>
          </Grid>

          {/* RIGHT COLUMN - BENEFITS */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: "24px",
                border: `1px solid ${colors.border}`,
                background: colors.primary,
                backdropFilter: "blur(10px)",
                p: 4,
                height: "fit-content",
                position: "sticky",
                top: 40,
              }}
            >
              {/* Title */}
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  color: colors.accent,
                  mb: 1,
                  letterSpacing: "0.3px",
                }}
              >
                Why Join Us?
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#666",
                  mb: 3,
                  lineHeight: 1.6,
                }}
              >
                Become a third-party interviewer and unlock earning opportunities
              </Typography>

              {/* Benefits List */}
              <List sx={{ mb: 3, p: 0 }}>
                {[
                  {
                    title: "Earn on Your Weekend",
                    desc: "Conduct interviews at your own pace during weekends and earn competitive compensation",
                  },
                  {
                    title: "Side Income Opportunity",
                    desc: "Build your supplementary income without compromising your primary job",
                  },
                  {
                    title: "Flexible Schedule",
                    desc: "Choose interview slots that fit your availability - complete control over your time",
                  },
                  {
                    title: "Professional Growth",
                    desc: "Enhance your interviewing skills and expand your professional network",
                  },
                  {
                    title: "Instant Payouts",
                    desc: "Get paid directly after each completed interview - quick and hassle-free",
                  },
                ].map((benefit, idx) => (
                  <ListItem
                    key={idx}
                    disableGutters
                    sx={{
                      alignItems: "flex-start",
                      mb: 2,
                      p: 0,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "auto",
                        mr: 2,
                        mt: 0.5,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 24,
                          height: 24,
                          borderRadius: "8px",
                          // background: colors.hoverBg,
                          border: `1.5px solid ${colors.accent}`,
                          color: colors.accent,
                          fontWeight: "bold",
                          fontSize: "14px",
                        }}
                      >
                        ✓
                      </Box>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 600,
                            color: colors.text,
                            mb: 0.5,
                          }}
                        >
                          {benefit.title}
                        </Typography>
                      }
                      secondary={
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#666",
                            lineHeight: 1.5,
                          }}
                        >
                          {benefit.desc}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>

              {/* Testimonial */}
              <Card
                sx={{
                  background: "rgba(255, 255, 255, 0.4)",
                  border: `1px solid ${colors.border}`,
                  borderRadius: "16px",
                  mb: 3,
                }}
              >
                <CardContent sx={{ display: "flex", gap: 2 }}>
                  <Box
                    component="img"
                    src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=96&auto=format&fit=crop"
                    alt="Interviewer"
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "8px",
                      objectFit: "cover",
                      border: `2px solid ${colors.accent}`,
                      flexShrink: 0,
                    }}
                  />
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{
                        color: colors.text,
                        fontWeight: 500,
                        lineHeight: 1.5,
                        display: "block",
                        mb: 0.5,
                      }}
                    >
                      "I earned ₹15,000+ in just 4 weekends! The platform is
                      user-friendly and payments are instant."
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#999",
                        fontStyle: "italic",
                        display: "block",
                      }}
                    >
                      — Rajesh Kumar, Senior Developer
                    </Typography>
                  </Box>
                </CardContent>
              </Card>

              {/* Stats */}
              <Grid container spacing={1.5} sx={{ mb: 3 }}>
                {[
                  { value: "₹500+", label: "Per Interview" },
                  { value: "2000+", label: "Active Interviewers" },
                ].map((stat, idx) => (
                  <Grid item xs={6} key={idx}>
                    <Card
                      sx={{
                        // background: `rgba(229, 157, 2, 0.1)`,
                        border: `1px solid ${colors.accent}`,
                        borderRadius: "12px",
                        textAlign: "center",
                        p: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: 700,
                          color: colors.accent,
                          mb: 0.5,
                        }}
                      >
                        {stat.value}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: "#666", fontSize: "12px" }}
                      >
                        {stat.label}
                      </Typography>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              {/* Trust Badges */}
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  flexWrap: "wrap",
                  pt: 3,
                  borderTop: `1px solid ${colors.border}`,
                }}
              >
                {["Secure Payments", "ISO Certified", "100% Transparent"].map(
                  (badge, idx) => (
                    <Typography
                      key={idx}
                      variant="caption"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                        color: "#666",
                        fontSize: "12px",
                      }}
                    >
                      <span
                        style={{
                          color: colors.accent,
                          fontWeight: "bold",
                        }}
                      >
                        ✓
                      </span>
                      {badge}
                    </Typography>
                  )
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default InterviewerJoining;